'use strict';

/**
 * View for rendering a single set in share menu
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/share-set.hbs');

var ShareSet = ColidoItemView.extend({
    template: template,

    tagName: 'li',

    modelEvents: {
        'change': 'render',
    },

    ui: {
        'shareSet': '[data-action="share-set"]',
    },

    events: {
        'click @ui.shareSet': 'shareSet',
    },

    shareSet: function(event) {
        var catalog = this.model.collection.catalog;

        //@todo why resolve:share:url if we already have the token? we just need the baseUrl
        App.radio('collection:set').execute('resolve:share:url', catalog, this.model.id, {
            success: function(url, model) {
                var conversation = this.getOption('conversation');

                if (url && conversation) {
                    var message = {
                        type: 'text',
                        data: url,
                    };

                    App.radio('community').execute('send:message:to:conversation', conversation, message, {
                        success: function(post) {
                            // Trigger change on model
                            // this.model.trigger('change');
                        }.bind(this),
                    });
                }
            }.bind(this),
        });
    },
});

module.exports = ShareSet;